<template>
  <div class="video-container" style="max-width: 100%; height: 100%; position: relative;">
    <div v-if="playing && waiting" style="position: absolute; display: flex; width: 100%; height: 100%; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: center;">
      <svg style="width: 150px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
          <stop offset="0" stop-color="#FFFFFF"></stop>
          <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
          <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
          <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
          <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
        </radialGradient>
        <circle transform-origin="center" fill="none" stroke="url(#a1)" stroke-width="16" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
          <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
        </circle>
        <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="16" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
      </svg>
    </div>

    <video ref="videoPlayer" class="" playsinline style="width: 100%; height: 100% !important;"></video>
  </div>
</template>

<script>
import {isIOS} from "mobile-device-detect";

export default {
  name: 'VideoPlayerCustom',
  props: {
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      src: '',
      startedPlaying: false,
      waiting: false,
      playing: false,
      player: null,
      totalTime: 0,
      progress: 0,
      videoWidth: 0,
      videoHeight: 0,

    };
  },
  beforeMount() {
    this.src = isIOS ? this.options.hlsUrl:  this.options.mpdUrl ;
  },
  mounted() {
    console.log(this.options,'VideoPlayer mounted');
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      const isHLS = isIOS && this.src.includes('.m3u8'); // Check if the source is an HLS stream
      const isDASH = this.src.includes('.mpd'); // Check if the source is a DASH stream

      const options = {
        autoplay: false,
        controls: false,
        preload: 'auto',
        techOrder: ['html5'],
      };

      if (isHLS) {
        // If the stream is HLS, use the HLS plugin
        options.sources = [{
          src: this.src,
          type: 'application/x-mpegURL', // HLS type
        }];
      } else if (isDASH) {
        // If the stream is DASH, use the DASH plugin (VHS)
        options.sources = [{
          src: this.src,
          type: 'application/dash+xml', // DASH type
        }];
      } else {
        console.error('Unsupported stream type!');
        return;
      }

      // Initialize Video.js player with VHS or HLS plugin based on the stream type
      this.player = videojs(this.$refs.videoPlayer, options, () => {
        console.log('Player ready');
        //get video height and width
        const videoElement = this.player.el().getElementsByTagName('video')[0]
        videoElement.addEventListener('loadedmetadata', () =>{
         this.videoWidth = videoElement.videoWidth; // Get the video width
          this.videoHeight = videoElement.videoHeight; // Get the video height
        });


        this.$emit('ready')
        this.$emit('loaded')
      });

      // Handle player events
      this.player.on('waiting', () => {
        this.waiting = true;
      });

      this.player.on('play', () => {

        if(!this.startedPlaying){
          if(this.videoWidth<this.videoHeight){
            this.$emit('fullScreen', true)
          }
        }
        this.startedPlaying =true
        this.playing = true;
        this.$emit('playing');
      });

      this.player.on('pause', () => {
        this.playing = false;
        this.$emit('paused');
      });

      this.player.on('ended', () => {
        this.playing = false;
        this.$emit('ended');
      });

      this.player.on('timeupdate', (e) => {

        const currentTime = this.player.currentTime();
        this.totalTime = this.player.duration();
        this.progress = (currentTime / this.totalTime) * 100;
        console.log(currentTime,this.player.duration())
        this.$emit('timeupdate', {percent: (currentTime / this.totalTime), seconds : currentTime   });
        this.$emit('durationupdate', currentTime);
      });
    },

    play() {
      this.player.play();
    },

    pause() {
      this.player.pause();
    },

    seekToPosition(position) {
      const seekTime = (this.totalTime * position) / 100;
      this.player.currentTime(seekTime);
    },

    stop() {
      this.player.pause();
      this.player.currentTime(0);
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-js {
  width: 100%;
  height: 100%;
}
</style>
